export default __webpack_public_path__ + "static/media/feature_3.f257f79b.png";